import { get, post } from '@/common/request/index';
import { cityList } from './city';

/**
 * 权限列表
 * https://yapi.lanhanba.com/project/176/interface/api/39934
 */
export function permissionsList() {
  return get('/v2/user/permissions', {}, true);
}

/**
 * 按编码查询用户权限
 */
export function getUserPermissionList(params?) {
  return get('/v2/user/permissionList', params, { needHint: false });
}

/**
 * 获取品牌列表
 * https://yapi.lanhanba.com/project/329/interface/api/40046
 */
export function getBrandList(params: any) {
  return post('/v2/brand/list', { ...params }, true);
}

/**
 * 新增品牌
 */
export function addBrand(params: any) {
  return post('/v2/brand/create', { ...params }, true);
}

/**
 * 行业列表
 * https://yapi.lanhanba.com/project/329/interface/api/40053
 */
export function industryList() {
  return get('/v2/industry/list', {}, true);
}

/**
 * 场地类型
 * https://yapi.lanhanba.com/project/329/interface/api/40088
 */
export function categoryList() {
  return post('/v2/category/list', {}, true);
}

/**
 * 场地列表
 * https://yapi.lanhanba.com/project/329/interface/api/40060
 */
export function placeList(params: any) {
  return post('/v2/place/list', params, true);
}


/**
 * 新增场地
 * https://yapi.lanhanba.com/project/329/interface/api/40060
 */
export function addPlace(params: any) {
  return post('/v2/place/create', params, true);
}


/**
 * 判断是否是指定的企业
 * https://yapi.lanhanba.com/project/176/interface/api/41187
 */
export function checkTenant() {
  return get('/v2/tenant/check', {}, { needCancel: false });
}

/**
 * 当前租户/企业信息
 * https://yapi.lanhanba.com/project/176/interface/api/34076
 */
export function curTenantInfo() {
  return get(`/v2/tenant/info`, {}, {
    needHint: true,
    needCancel: false,
  });
}

/**
 * 租户信息-分享场景下用（不用token就能查询，避免返回隐私信息）
 * https://yapi.lanhanba.com/project/176/interface/api/85672
 */
export function curTenantShareInfo(params: any) {
  return get(`/v2/tenant/shareInfo`, { ...params }, {
    needHint: true,
    needCancel: false,
  });
}

/**
 * 当前用户信息
 */
export function getCurrentUserInfo() {
  return get('/v2/user/currentUser', {}, {
    needCancel: false,
  });
}

/**
 * 根据高德地图code 返回数据库中的省市区
 * https://yapi.lanhanba.com/project/469/interface/api/52898
 */
export function accordingToCodeMap(params: any) {
  return get(`/v2/area/search/code`, { ...params }, {
    isMock: false,
    needHint: true,
  });
}

/**
 * 当前菜单列表
 * https://yapi.lanhanba.com/project/469/interface/api/52492
 */
export function getMenuList() {
  return get(`/v2/user/menu/list`, {}, {
    isMock: false,
    mockId: 469,
    needHint: true,
    needCancel: false,
  });
}

export function getConfigInfo(key) {
  return get('/api/config/info', { key }, {
    isMock: false,
    mockId: 469,
    needHint: false,
  });
}

/**
 * 飞书免登：https://yapi.lanhanba.com/project/378/interface/api/79967
 */
export function loginByLark(params) {
  return post('/fs/login', { ...params }, {
    isMirage: true,
    needHint: true,
  });
}


/**
 * 飞书免登：https://yapi.lanhanba.com/project/378/interface/api/84286
 */
export function authenticationByLark(params) {
  return get('/tp/feishu/jsapi/signature', { ...params }, {
    isMirage: true,
    needHint: true,
    // needCancel: false,
  });
}



/**
 * 校验token是否有效：https://yapi.lanhanba.com/project/378/interface/api/36882
 */
export function checkToken(params) {
  return get('/checkToken', { ...params }, {
    isMirage: true,
    needHint: false, // 不要抛错
    // needCancel: false,
  });
}


// /**
//  * 校验企业
//  * https://yapi.lanhanba.com/project/297/interface/api/41208
//  */
// export function tenantCheck(params?: any) {
//   return get('/api/tenant/check', { ...params }, {
//     needCancel: false,
//     isMock: false
//   });
// };

export const getCityList = cityList;


/**
 * 创建短链 并返回分享id（下发临时token）
 * https://yapi.lanhanba.com/project/623/interface/api/87324
 */
export function createShareLink(params?: any, config?: any) {
  return post('/v2/share/shortLink/createShortLink', { ...params }, {
    needHint: true,
    ...config
  });
}


/**
 * 根据分享id获取请求体内容
 * https://yapi.lanhanba.com/project/532/interface/api/76964
 */
export function getShareContent(params?: any, config?: any) {
  return get('/v2/share/shortLink/getShortLinkInfo', { ...params }, {
    needHint: true,
    needCancel: false,
    ...config,
  });
}

/**
 * oss上传 预签名
 * https://yapi.lanhanba.com/project/297/interface/api/90253
 */
export function signFile(params?: any) {
  return post(`/v2/oss/preSign`, params, { needCancel: false });
}


/**
 * 企微登录-获取授权网址
 * https://yapi.lanhanba.com/project/378/interface/api/59324
 */
export function getWeComAuthorizeLink(params?: any) {
  return post(`/tp/wx/oauth2/authorize`, params, {
    isMirage: true,
    needHint: true,
  });
}

/**
 * 企微登录-拿code换token
 * https://yapi.lanhanba.com/project/378/interface/api/78007
 */
export function loginQW(params: any) {
  return post(`/wxOauth2/login`, params, {
    isMirage: true,
    needHint: true,
  });
}

/**
 * 获取企业微信 agentConfig 配置
 * @param params 包含 url 参数
 */
export function getWxWorkAgentConfig(params: any) {
  return get('/v2/tp/wx/getWebConfig', { ...params }, {
    needHint: true,
  });
}


/**
 * 获取品牌列表(竞品品牌使用)
 * https://yapi.lanhanba.com/project/329/interface/api/101172
 */
export function getMDBrandList(params: any) {
  return post('/v2/md/brand/list', { ...params }, {
    needHint: true,
    needCancel: false,
  });
}

/**
 * 行业列表(竞品品牌使用)
 * https://yapi.lanhanba.com/project/329/interface/api/101166
 */
export function getMDIndustryList() {
  return get('/v2/md/industry/list', {}, {
    needHint: true,
    needCancel: false,
  });
}

/**
 * 创建品牌(竞品品牌使用)
 * https://yapi.lanhanba.com/project/329/interface/api/101190
 */
export function createMDBrand(params: any) {
  return post('/v2/md/brand/create', params, true);
}
